import { SymbolName, TickRequest } from '../../../grpc/generated/symbol_pb';
import SubscribeOnTick from '../../../data/onTickSubscribe';
import { metadata } from '../../../data/metadata';
import { useEffect, useState } from 'react';
import emitter from '../../../utilities/emitter';
import { useAppDispatch } from '../../../redux/app';
import { setTick } from '../../../redux/reducer/stat';

const useSubscribe = () => {
  const dispatch = useAppDispatch();
  
  const subscribe = async (symbolArr) => {
    try {
      const request = new TickRequest();
      const requestTick = new SubscribeOnTick();
      for (let index = 0; index < symbolArr.length; index++) {
        const sym = symbolArr[index];
        const symbol = new SymbolName();
        symbol.setName(sym);
        request.addSymbols(symbol);
      }
      await requestTick.subScribeBidAsk(request, metadata());
    } catch (err) {
      console.log(err);
    }
  };

  const unsubscribe = async (symbolArr) => {
    try {
      const request = new TickRequest();
      for (let index = 0; index < symbolArr.length; index++) {
        const sym = symbolArr[index];
        const symbol = new SymbolName();
        symbol.setName(sym);
        request.addSymbols(symbol);
      }
      const requestTick = new SubscribeOnTick();
      await requestTick.unSubScribeBidAsk(request, metadata());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    emitter.instance.on('TickData', (data) => {
      dispatch(setTick(data))
    });
  }, []);
  
  return { subscribe, unsubscribe };
};

export default useSubscribe;